import { DEMO_FONT_FAMILY, HOSPITAL_DEMO } from "../../theme/tokens";

export function drawShiftCircleImsSrc(shift: any, font_size: number, force_circle_radios = 0, isDemo = false) {
	let dataString = shift ? shift.staffNo.toString() : "";
	if (shift?.isPlusActive) dataString += "+";
	else if (shift?.isMinusActive) dataString += "-";
	const confidence = shift?.certainty ? shift.certainty : 1;

	// Medium ("at target") node color. Demo-only: neutral gray so it reads calm and doesn't
	// compete with the orange/blue signal nodes. Real depts (Assuta) keep the theme primary.
	const MEDIUM_GRAY = isDemo ? HOSPITAL_DEMO.NODE_MEDIUM : "var(--inhouse-primary-light)";
	let fillColor;
	switch (shift?.staffDifficulty) {
		case "high":
			// Demo: red high node; others keep orange.
			fillColor = confidence < 1 ? "rgb(225, 225, 225)" : isDemo ? HOSPITAL_DEMO.NODE_HIGH : "#FFA96A";
			break;
		case "low":
			// Demo: blue low node; others keep the original blue.
			fillColor = confidence < 1 ? "rgb(225, 225, 225)" : isDemo ? HOSPITAL_DEMO.NODE_LOW : "#5EB8F9";
			break;
		default:
			fillColor = confidence < 1 ? "rgb(225, 225, 225)" : MEDIUM_GRAY;
	}

	let borderColor;
	switch (shift?.staffDifficulty) {
		case "high":
			// Demo: red high node; others keep orange.
			borderColor = isDemo ? HOSPITAL_DEMO.NODE_HIGH : "#FFA96A";
			break;
		case "low":
			// Demo: blue low node; others keep the original blue.
			borderColor = isDemo ? HOSPITAL_DEMO.NODE_LOW : "#5EB8F9";
			break;
		default:
			borderColor = MEDIUM_GRAY;
	}

	const scaleSize = (size: number) => ((size * window.innerWidth) / 1920) * 1.3;

	const svgNS = "http://www.w3.org/2000/svg";
	const svg = document.createElementNS(svgNS, "svg");
	const scaledWidth = scaleSize(60);
	const scaledHeight = scaleSize(60);
	svg.setAttribute("width", scaledWidth.toString());
	svg.setAttribute("height", scaledHeight.toString());
	svg.setAttribute("viewBox", `0 0 ${scaledWidth} ${scaledHeight}`);

	const circle = document.createElementNS(svgNS, "circle");
	const scaledRadius = force_circle_radios || scaleSize(20);
	circle.setAttribute("cx", (scaledWidth / 2).toString());
	circle.setAttribute("cy", (scaledHeight / 2).toString());
	circle.setAttribute("r", scaledRadius.toString());
	circle.setAttribute("fill", fillColor);

	const text = document.createElementNS(svgNS, "text");
	text.setAttribute("x", (scaledWidth / 2).toString());
	text.setAttribute("y", (scaledHeight / 2).toString());
	text.setAttribute("text-anchor", "middle");
	text.setAttribute("dominant-baseline", "central");
	// Hospital demo draws node numbers in DM Sans to match the rest of the Shift Insights page.
	text.setAttribute("font-family", isDemo ? DEMO_FONT_FAMILY : "Arial");
	text.setAttribute("font-size", scaleSize(font_size).toString());
	text.setAttribute("fill", "white");
	text.textContent = dataString;

	if (confidence < 1) {
		circle.setAttribute("stroke", "rgb(210, 210, 210)");
		circle.setAttribute("stroke-width", "3");
		circle.setAttribute("stroke-dasharray", "5,5");
	}

	svg.appendChild(circle);
	svg.appendChild(text);

	const serializer = new XMLSerializer();
	const svgString = serializer.serializeToString(svg);
	const encodedData = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
	return encodedData;
}
